import React, { type FC, type ReactNode } from 'react'
import { useCreatedBoxes } from '../hooks/useCreatedBoxes'
import {
  CreatedBoxesMetaDtoOrderByEnum,
  CreatedBoxesMetaDtoOrderDirectionEnum,
} from '../types/generated'
import { ScrollBoxes } from './ScrollBoxes'

export const CreatedBoxesScrollBoxes: FC<{
  titleElement: ReactNode | null
  tabsElement: ReactNode
}> = ({ titleElement, tabsElement }) => {
  const {
    data,
    fetchNextPage,
    isFetching,
    refetch,
    isFetchingNextPage,
    isError,
  } = useCreatedBoxes({
    orderBy: CreatedBoxesMetaDtoOrderByEnum.CreatedAt,
    orderDirection: CreatedBoxesMetaDtoOrderDirectionEnum.Desc,
  })

  return (
    <ScrollBoxes
      data={data}
      fetchNextPage={fetchNextPage}
      isFetching={isFetching}
      isFetchingNextPage={isFetchingNextPage}
      isError={isError}
      refetch={refetch}
      titleElement={titleElement}
      tabsElement={tabsElement}
      filterType="my"
    />
  )
}
